import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { emit } from '@/lib/analytics';
import { useSession } from '@/contexts/session-context';
import { sanitizeReturnTo } from '@/lib/sanitize-return-to';

/**
 * Phase 118 — LandingPage renders the unauth UI only.
 *
 * Auth-redirect logic lives in RootRedirect (mounted at `/`) — it decides
 * whether to render LandingPage (unauth) or <Navigate to /w/:ws> (auth).
 * LandingPage is never reached by an authed user.
 */
export function LandingPage() {
  const { isLoading, signIn } = useSession();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  const handleSignIn = () => {
    emit('sign_in_clicked', {});
    const stashed = sessionStorage.getItem('hookmyapp:auth:returnTo');
    const returnTo = sanitizeReturnTo(stashed);
    signIn({ returnTo });
  };

  const handleSignUp = () => {
    emit('sign_up_clicked', {});
    // WorkOS hosted UI presents both sign-in and sign-up; backend /auth/login
    // is the single entry point for both flows under cookie auth.
    signIn();
  };

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-6"
      style={{ fontFamily: "'Montserrat', sans-serif" }}
    >
      <img src="/logo-mark.png" alt="HookMyApp" className="h-28 w-28" />
      <h1 className="text-4xl font-semibold">HookMyApp</h1>
      <p className="text-lg text-muted-foreground">
        No Bureaucracy. Just Start Messaging.
      </p>
      <div className="flex flex-col gap-2 sm:flex-row">
        <Button size="lg" onClick={handleSignIn}>
          Sign in
        </Button>
        <Button size="lg" variant="outline" onClick={handleSignUp}>
          Create account
        </Button>
      </div>
    </div>
  );
}
